<template>
  <div
    class="question-wrap"
    :class="[
      {isLine: value.type === QTypes.LINE},
      {isRemark: value.type === QTypes.REMARK},
    ]"
  >
    <div
      v-if="value.ext && value.ext.edit"
      class="sort"
      style="width: 100%; text-align: center; cursor: move; position: absolute"
    >
      <img
        width="40"
        style="cursor: move; dragable: false; display: inline-block"
        src="http://cnstatic01.e.vhall.com/static/images/signup-form/drop.png?v=o78iE3bYNdTd377uDRu6Jw%3D%3D"
        alt=""
      />
    </div>
    <div class="question-content" @click.stop="questionClick">
      <div
        class="index"
        :class="[
          {isLine: value.type === QTypes.LINE},
          {isRemark: value.type === QTypes.REMARK},
        ]"
      >
        <span
          class="require-icon"
          v-if="value.required === 'Y'"
          style="color: red"
          >*</span
        >
        {{ getIndex }}.
      </div>
      <div class="q-edit display">
        <div v-if="value.ext && value.ext.edit" class="q-subject">
          <span v-if="value.type === QTypes.RADIO && value.style == 'radio'">
            {{ $t("quest.k_2001") }}
          </span>
          <span v-else-if="value.style === QTypes.MULTIPLE_SELECT">{{
            $t("quest.k_2002")
          }}</span>
          <span v-else-if="value.type === QTypes.CHECKBOX">{{
            $t("quest.k_2003")
          }}</span>

          <span v-else-if="value.type === QTypes.SELECT">{{
            $t("quest.k_2004")
          }}</span>
          <span v-else-if="value.type === QTypes.AREA">{{
            $t("quest.k_2005")
          }}</span>
          <span v-else-if="value.type === QTypes.REMARK">{{
            $t("quest.k_2006")
          }}</span>
          <span v-else-if="value.style === QTypes.COMPANY">{{
            $t("quest.k_2007")
          }}</span>
          <span v-else-if="value.style === QTypes.POSTION">{{
            $t("quest.k_2008")
          }}</span>
          <span v-else-if="value.style === QTypes.NAME">{{
            $t("quest.k_2009")
          }}</span>
          <span v-else-if="value.style === QTypes.SEX">{{
            $t("quest.k_2010")
          }}</span>
          <span v-else-if="value.style === QTypes.PHONE">{{
            $t("quest.k_2011")
          }}</span>
          <span v-else-if="value.style === QTypes.EMAIL">{{
            $t("quest.k_2012")
          }}</span>
          <span v-else-if="value.style === QTypes.BIRTHDAY">{{
            $t("quest.k_2013")
          }}</span>
          <span v-else-if="value.style === QTypes.INDUSTRY">{{
            $t("quest.k_2014")
          }}</span>
          <span v-else-if="value.style === QTypes.EDUCATION">{{
            $t("quest.k_2015")
          }}</span>
          <span v-else-if="value.type === QTypes.TEXT">{{
            $t("quest.k_2016")
          }}</span>
        </div>
        <div v-else class="q-subject">
          <!-- <span v-if="value.required==='Y'" style="color:red">*</span> -->
          <span v-html="value.title"></span>
        </div>
        <div v-if="value.type === QTypes.LINE" class="line"></div>
        <!-- 问题描述区 -->
        <com-input
          v-if="showInputCom"
          class="q-subject"
          :placeholder="$t('quest.k_2017')"
          @click.stop=""
          @change="changeTitle"
          @focus="focusTitle"
          :class="{error: value.error}"
          v-model="value.title"
          :max-length="100"
        ></com-input>

        <!-- 问题描述区 -->
        <div>
          <component
            ref="content"
            :isPreview="isPreview"
            :isReplay="isReplay"
            :is="
              ['phone', 'privacy', 'q-select-multiple'].includes(value.ext.type)
                ? value.ext.type
                : QComs[value.type]
            "
            v-model="value"
          ></component>
        </div>
      </div>
      <div class="q-operate" @click.stop="" v-if="value.ext && value.ext.edit">
        <div class="q-operate-left">
          <a
            v-if="value.type === QTypes.MATRIX"
            class="add-row-item"
            @click="addRowItem"
          >
            {{ $t("quest.k_2018") }}
          </a>
          <a
            v-if="value.type === QTypes.MATRIX"
            class="add-column-item"
            @click="addColumnItem"
          >
            {{ $t("quest.k_2019") }}
          </a>
          <a
            v-if="showAddItem || value.type === QTypes.SELECT"
            class="add-select-item"
            :class="{disabledAdd: value.detail.list.length >= 30}"
            @click="addItem"
          >
            <i class="vh-icon-plus"></i>
            {{ $t("quest.k_2020") }}
          </a>
          <span
            class="line add-other-item"
            v-if="showAddItem && value.style != QTypes.MULTIPLE_SELECT"
          ></span>
          <a
            v-if="showAddItem && value.style != QTypes.MULTIPLE_SELECT"
            class="add-select-item add-other-item"
            :class="{
              disabledAdd:
                value.detail.list.length >= 30 ||
                value.detail.list.some((i) => i.custom_opt == 1),
            }"
            @click="addOtherItem"
          >
            <i class="vh-icon-plus"></i>
            {{ $t("quest.k_2021") }}
          </a>
          <span
            v-if="showAddItem || value.type === QTypes.SELECT"
            class="addTip"
          >
            {{ $t("quest.k_2022") }}
          </span>
        </div>

        <div class="q-operate-right">
          <div
            v-if="
              (value.type == QTypes.CHECKBOX ||
                value.style == QTypes.MULTIPLE_SELECT) &&
              verifiy
            "
            class="min-max-select"
          >
            {{ $t("quest.k_2023") }}
            <vh-select
              :placeholder="$t('quest.k_2024')"
              size="mini"
              v-model="value.detail.min"
            >
              <vh-option :label="$t('quest.k_2025')" :value="-1"></vh-option>
              <vh-option
                v-for="(item, index) in value.detail.list"
                :disabled="value.detail.max > 0 && index + 1 > value.detail.max"
                :key="index"
                :label="index + 1 + $t('quest.k_2026')"
                :value="index + 1"
              ></vh-option>
            </vh-select>
            &nbsp;&nbsp;最多
            <vh-select
              :placeholder="$t('quest.k_2028')"
              size="mini"
              v-model="value.detail.max"
            >
              <vh-option :label="$t('quest.k_2025')" :value="-1"></vh-option>
              <vh-option
                v-for="(item, index) in value.detail.list"
                :disabled="value.detail.min > 0 && index + 1 < value.detail.min"
                :key="index"
                :label="index + 1 + $t('quest.k_2026')"
                :value="index + 1"
              ></vh-option>
            </vh-select>
          </div>
          <div class="del" @click.stop="remove">
            <i class="iconfont-v3 saasicon-trash"></i>
            <!-- <i class="vh-icon-delete"></i> -->
          </div>
          <span
            v-if="showRequire && value.ext && value.ext.edit"
            class="required-des"
          >
            {{ $t("quest.k_2029") }}
          </span>
          <vh-switch
            class="switch"
            :key="index"
            v-if="showRequire && value.ext && value.ext.edit"
            v-model="verifiy"
            active-color="#FB3A32"
            inactive-color="#CECECE"
            size="mini"
            :width="32"
          ></vh-switch>
          <!--
        复制功能
        <div class="copy"
            @click="copy">
              <i class="vh-icon-document-copy"></i>
        </div>
      -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {coms as QComs, types as QTypes} from "./types";
import qRadio from "./q-radio.vue";
import qCheckbox from "./q-checkbox.vue";
import qSelect from "./q-select.vue";
import qSelectMultiple from "./q-select-multiple.vue";
import qText from "./q-text.vue";
import qDate from "./q-date.vue";
import qArea from "./q-area.vue";
import qMatrix from "./q-matrix.vue";
import qLine from "./q-line.vue";
import qRemark from "./q-remark.vue";
import qPosition from "./q-position.vue";
import qCompany from "./q-company.vue";
import ComInput from "../input/com.vue";
import phone from "../input/phone.vue";

export default {
  components: {
    qRadio,
    qCheckbox,
    qSelect,
    qSelectMultiple,
    qText,
    qDate,
    qArea,
    qMatrix,
    qLine,
    qRemark,
    qPosition,
    qCompany,
    "com-input": ComInput,
    phone,
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    isPreview: Boolean,
    isReplay: Boolean,
    index: Number,
    detail: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      QComs: QComs,
      QTypes: QTypes,
      verifiy: false,
    };
  },
  mounted() {
    console.log(this.value, "1222221111111");
    if (this.value.required === "Y") {
      this.verifiy = true;
    }
  },
  methods: {
    validate() {
      if (this.value.error || !this.value.title) {
        this.value.error = true;
        this.value.title = this.$t("quest.k_2030");
        return false;
      }
      if (
        this.value.type === QTypes.RADIO ||
        this.value.type === QTypes.CHECKBOX ||
        this.value.type === QTypes.SELECT ||
        this.value.style === QTypes.MULTIPLE_SELECT
      ) {
        let result = true;
        this.value.detail.list.forEach((item) => {
          if (
            !item.value ||
            (item.error && item.value === this.$t("quest.k_2031"))
          ) {
            result = false;
            item.value = this.$t("quest.k_2031");
            item.error = true;
          } else {
            item.error = false;
          }
        });
        return result;
      }
      if (this.value.type === QTypes.MATRIX) {
        let result = true;
        this.value.detail.row.forEach((item) => {
          if (
            !item.value ||
            (item.error && item.value === this.$t("quest.k_2031"))
          ) {
            result = false;
            item.value = this.$t("quest.k_2031");
            item.error = true;
          } else {
            item.error = false;
          }
        });
        this.value.detail.column.forEach((item) => {
          if (
            !item.value ||
            (item.error && item.value === this.$t("quest.k_2031"))
          ) {
            result = false;
            item.value = this.$t("quest.k_2031");
            item.error = true;
          } else {
            item.error = false;
          }
        });
        return result;
      }
      return true;
    },
    check() {
      return this.$refs.content.check();
    },
    questionClick() {
      this.$emit("click", this);
    },
    changeTitle(e) {
      if (!this.value.title) {
        this.value.title = e;
      }
    },
    focusTitle() {
      console.log(this.value, this.value.title, "???????????????");
      if (this.value.error) {
        this.value.title = "";
        this.value.error = false;
      }
    },
    addRowItem() {
      if (this.value.detail.row.length < 20) {
        let obj = {
          value: this.$t("quest.k_2032"),
        };
        if (this.value.detail.format === "checkbox") {
          obj.selected = [];
        }
        this.value.detail.row.push(obj);
      }
    },
    addColumnItem() {
      if (this.value.detail.column.length < 20) {
        this.value.detail.column.push({
          value: this.$t("quest.k_2032"),
        });
      }
    },
    addItem() {
      if (this.value.detail.list.length < 30) {
        this.value.detail.list.push({
          value: this.$t("quest.k_2032"),
          isAdd: true,
          is_answer: 0,
        });
      }
    },
    addOtherItem() {
      if (this.value.detail.list.some((i) => i.custom_opt == 1)) return false;
      if (this.value.detail.list.length < 30) {
        this.value.custom_ques = 1;
        this.value.detail.list.push({
          value: this.$t("quest.k_2033"),
          isAdd: true,
          is_answer: 0,
          custom_opt: 1,
        });
      }
    },
    copy() {
      console.log(this.value);
      this.$emit("copy", {
        index: this.index,
        value: this.value,
      });
    },
    remove() {
      this.$emit("remove", this.index);
    },
  },
  watch: {
    verifiy: {
      handler(val) {
        if (val) {
          this.value.required = "Y";
        } else {
          this.value.required = "N";
        }
      },
      deep: true,
    },
    value: {
      handler(val) {
        if (this.value.required === "Y") {
          this.verifiy = true;
        } else {
          this.verifiy = false;
        }
      },
      deep: true,
    },
    "value.detail.list.length": function (val) {
      this.value.detail.max > val && (this.value.detail.max = null);
      this.value.detail.min > val && (this.value.detail.min = null);
    },
  },
  computed: {
    getIndex() {
      let i = 0;
      for (let j = 0, len = this.detail.length; j < len; j++) {
        if (
          this.detail[j].type === this.QTypes.LINE ||
          this.detail[j].type === this.QTypes.REMARK
        ) {
          continue;
        }
        if (this.detail[j] === this.value) {
          break;
        }
        i++;
      }
      return i + 1;
    },
    showAddItem() {
      return (
        this.value.type === this.QTypes.RADIO ||
        this.value.type === this.QTypes.CHECKBOX
      );
    },
    showTitle() {
      return (
        this.value.type !== this.QTypes.LINE &&
        this.value.type !== this.QTypes.REMARK
      );
    },
    showRequire() {
      return (
        this.value.type !== this.QTypes.LINE &&
        this.value.type !== this.QTypes.REMARK
      );
    },
    showInputCom() {
      return (
        this.value.ext &&
        this.value.ext.edit &&
        this.value.type !== this.QTypes.LINE
      );
    },
  },
};
</script>

<style scoped lang="scss">
.question-wrap {
  width: 100%;
  font-size: 12px;
  position: relative;
  border-radius: 4px;
  background: #fff;
  border: 1px solid transparent;
  margin-top: 30px;
  &:hover {
    border: 1px solid #fb3a32;
  }
  &.isLine {
    border: 0;
    margin-bottom: 0;
    .question-content {
      .q-edit {
        margin-left: 0;
      }
    }
  }
  &.isRemark {
    .question-content {
      .q-edit {
        margin-left: 0;
        &.display {
          .q-subject {
            span {
              color: #1a1a1a;
            }
          }
        }
      }
    }
  }
  ::v-deep {
    .com-input {
      width: 100%;
      height: 40px;
      &.area {
        height: 80px;
      }
      input {
        font-size: 14px;
        height: 40px;
      }
    }
    .index {
      float: left;
      font-size: 14px;
      color: #1a1a1a;
      line-height: 20px;
      margin-right: 4px;
      &.isLine {
        display: none;
      }
      &.isRemark {
        display: none;
      }
    }
    .question-content {
      padding: 20px;
      width: 100%;
      background-color: #fff;
      border-radius: 4px;
      .q-edit {
        /*margin-left: 20px;*/
        /*margin-bottom: 15px;*/
        &.display {
          // margin-bottom: 0;
        }
        .q-subject {
          margin-bottom: 14px;
          font-size: 14px;
          color: #1a1a1a;
          word-break: break-all;
          display: inline-block;
          &.error {
            input {
              border-color: #fc5659;
              color: #fc5659;
            }
            .limit {
              display: none;
            }
          }
        }
        .line {
          border-bottom: 1px solid #dadada;
        }
      }
      .q-operate {
        padding-left: 15px;
        text-align: right;
        overflow: hidden;
        .q-operate-left {
          float: left;
          height: 24px;
          line-height: 24px;
          margin-bottom: 5px;
        }
        .q-operate-right {
          float: right;
        }
        .add-select-item,
        .add-row-item,
        .add-column-item {
          cursor: pointer;
          margin-top: 6px;
          color: #3562fa;
          font-size: 14px;
          &:hover {
            color: #3562fa;
          }
        }
        .add-row-item {
          margin-right: 10px;
        }
        .disabledAdd {
          color: #8c8c8c;
          &:hover {
            color: #8c8c8c;
            cursor: initial;
          }
        }
        .line {
          width: 2px;
          height: 13px;
          background: #999999;
          display: inline-block;
          margin: 0 12px 0;
          vertical-align: middle;
        }
        .addTip {
          padding: 6px 0 0 8px;
          font-size: 14px;
        }
        .required-des {
          display: inline-block;
          vertical-align: middle;
          color: #666;
          font-size: 14px;
          padding-left: 5px;
        }

        .sort {
          position: relative;
          display: inline-block;
          text-align: center;
          width: 30px;
          height: 30px;
          line-height: 30px;
          border-radius: 30px;
          cursor: pointer;
          font-size: 18px;
          margin-left: 10px;
          border-radius: 4px;
          vertical-align: middle;
          &:hover {
            color: #fc5659;
          }
        }
        .copy {
          @extend .sort;
        }
        .del {
          @extend .sort;
          width: 17px;
          vertical-align: middle;
          line-height: 33px;
          // padding-right: 5px;
          i {
            font-size: 24px;
          }
        }
        .min-max-select {
          display: inline-block;
          vertical-align: middle;
          .vh-select {
            width: 76px;
          }
        }
      }
    }
  }
}

.q-wrap {
  .question-wrap {
    margin-bottom: 0;
  }
  .question-content {
    padding: 0px 20px;
    .q-edit .q-subject {
      margin-bottom: 0;
      color: #1a1a1a;
      font-size: 14px;
      min-height: 18px;
      word-break: break-all;
      max-width: calc(100% - 35px);
      display: inline-block;
      span {
        font-size: 14px;
        line-height: 18px;
      }
    }
    ::v-deep {
      .item-text {
        font-size: 14px !important;
      }
      .vh-radio__input {
        margin-top: 10px;
      }
      .select {
        margin-top: 10px;
      }
      input {
        font-size: 14px;
        height: 40px;
      }
    }
  }
  .index {
    font-size: 14px;
    color: #1a1a1a;
  }
}
.require-icon {
  vertical-align: middle;
  margin-right: 4px;
}
</style>
